import css from "styled-jsx/css";
import { ALWAYS_ON_TOP } from "constants/z-index";

export const componentStyles = css.global`
  .switch-checkbox {
    height: 0;
    width: 0;
    position: absolute;
    visibility: hidden;
  }

  .switch {
    cursor: pointer;
    width: 500px;
    height: 40px;
    border-radius: 30px;
    background-color: var(--background-color);
    position: relative;
    transition: background-color 0.2s;

    .switch-button {
      position: absolute;
      left: 0px;
      width: 250px;
      height: 40px;
      border-radius: 30px;
      transition: 0.2s;
      background-color: var(--switch-color);
      box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
    }
  }

  .switch-checkbox:checked + .switch-button {
    left: 100%;
    transform: translateX(-100%);
  }

  .switch-checkbox:active + .switch-button {
    width: 200px;
  }

  .switch-labels {
    display: relative;
    height: 100%;
    .switch-text {
      color: var(--is-off-color);
      &.is-on {
        color: var(--is-on-color);
      }
    }
  }

  .switch-labels span {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 100%;
  }
  .switch-labels span:first-child {
    left: 0;
  }
  .switch-labels span:last-child {
    right: 0;
  }
`;
